import { createApp } from 'vue'
import App from './App.vue'
import { router } from './router'
import './styles/main.css'

const root = document.getElementById('app')
const hasBootstrap = root?.hasAttribute('data-bondpet-bootstrap') === true
const bootstrap = root?.getAttribute('data-bondpet-bootstrap')
if (hasBootstrap) {
  try {
    const value = JSON.parse(bootstrap ?? '') as unknown
    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
      window.__BONDPET_PUBLIC_BOOTSTRAP__ = value as Record<string, unknown>
      window.__BONDPET_PUBLIC_BOOTSTRAP_MALFORMED__ = false
    } else {
      window.__BONDPET_PUBLIC_BOOTSTRAP_MALFORMED__ = true
    }
  } catch {
    window.__BONDPET_PUBLIC_BOOTSTRAP_MALFORMED__ = true
  }
  root.removeAttribute('data-bondpet-bootstrap')
}

createApp(App).use(router).mount('#app')
